module.exports = flarum.core.compat['components/UsersSearchSource'];